module.exports = __webpack_public_path__ + "img/country@2x.e721bb8f.png";